export default "__VITE_ASSET__CJOmmzs0__"